import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PILL } from './styles';
import { livyJson } from 'src/lib/livyApi';
/**
 * The opening screen is where most people learn what this can do, and a handful of starter cards
 * understated it badly: the assistant reaches dozens of tools and advertised four questions.
 *
 * The groups come from the server, matched against the caller's own allowlist, so this cannot offer
 * a resident something only staff can reach, and cannot go stale when a tool is added.
 */
export function LivyCapabilities(_ref) {
  let surface = _ref.surface,
    onAsk = _ref.onAsk;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    groups = _useState2[0],
    setGroups = _useState2[1];
  useEffect(() => {
    let live = true;
    livyJson("/capabilities?surface=".concat(encodeURIComponent(surface)))
    // A failure here costs the reader a list, not the chat: the composer still works.
    .then(d => live && setGroups(d.groups)).catch(() => live && setGroups([]));
    return () => {
      live = false;
    };
  }, [surface]);
  if (!groups || groups.length === 0) return null;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      maxWidth: 640,
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 10.5,
      letterSpacing: '.08em',
      textTransform: 'uppercase',
      color: 'text.secondary',
      mb: '10px'
    }
  }, "Everything I can look at"), /*#__PURE__*/React.createElement(Stack, {
    spacing: "14px"
  }, groups.map(g => /*#__PURE__*/React.createElement(Box, {
    key: g.label
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    alignItems: "baseline",
    spacing: "8px",
    sx: {
      mb: '5px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13.5,
      fontWeight: 600
    }
  }, g.label), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11.5,
      color: 'text.secondary',
      fontVariantNumeric: 'tabular-nums'
    }
  }, g.count, " ", g.count === 1 ? 'tool' : 'tools')), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: "8px",
    sx: {
      flexWrap: 'wrap',
      rowGap: '8px'
    }
  }, g.asks.map(a => /*#__PURE__*/React.createElement(Button, {
    key: a,
    disableRipple: true,
    onClick: () => onAsk(a),
    sx: PILL
  }, a)))))));
}